import { type ReactElement } from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { getTypeIcon, getTypeLabel } from 'screens/TripDetails/TripDetails.helpers'
import type { StopData } from './TripDetails.types'

export interface StopTypeProps {
  stop: StopData
}

const StopType = ({ stop }: StopTypeProps): ReactElement => {
  const TypeIcon = getTypeIcon(stop.type)

  return (
    <Stack spacing={0.5} direction="row" alignItems="center">
      <TypeIcon sx={{ color: 'primary.main', fontSize: '1rem' }} />
      <Typography color="primary.main" variant="p6">
        {getTypeLabel(stop.type)}
      </Typography>
    </Stack>
  )
}

export default StopType
